import React, { useEffect, useState, useRef } from "react";

import styles from "./slider.module.scss";

import DraggingIcon from "../../../assets/svg/DraggingIcon.jsx";

import { useScrollBoost } from "react-scrollbooster";
import classNames from "classnames";
import { throttle } from "lodash";

const DragImg = ({ image }) => {
  const [viewport, scrollbooster] = useScrollBoost({
    scrollMode: "native",
    direction: "horizontal",
    friction: 0.05,
    bounce: false,
  });

  const [isDragging, setIsDragging] = useState(false);

  const handleMouseDown = () => {
    setIsDragging(true);
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleMouseLeave = () => {
    setIsDragging(false);
  };

  const [isLoaded, setIsLoaded] = useState(false); // Состояние для отслеживания загрузки

  const containerRef = useRef(null);
  const imgRef = useRef(null); // Ref для изображения

  // Функция для обновления размеров контейнера
  const updateContainerSize = () => {
    const img = imgRef.current;

    if (img && containerRef.current && scrollbooster) {
      const { naturalWidth, naturalHeight } = img;
      const viewportHeight = window.innerHeight;
      const scale = viewportHeight / naturalHeight;
      const scaledWidth = naturalWidth * scale;

      containerRef.current.style.width = `${scaledWidth}px`;
      scrollbooster.updateMetrics();
    }
  };

  // Throttled версия обработчика ресайза
  const throttledUpdate = throttle(updateContainerSize, 200); // Ограничение: 200 мс

  useEffect(() => {
    const img = imgRef.current;

    if (img && scrollbooster) {
      // Ждём загрузки изображения
      img.onload = () => {
        updateContainerSize(); // Устанавливаем размеры при загрузке

        img.classList.add(styles.DragImg__imgShow); // Добавляем класс сразу, если изображение уже загружено
      };

      if (img.complete) {
        img.onload();
      }
    }

    // Добавляем обработчик ресайза
    window.addEventListener("resize", throttledUpdate);

    return () => {
      if (img) img.onload = null; // Очистка

      window.removeEventListener("resize", throttledUpdate); // Очистка
    };
  }, [scrollbooster, throttledUpdate]);

  const imgStyle = classNames(styles.DragImg__img, {
    [styles.DragImg__imgShow]: isLoaded, // Добавляем класс при загрузке
    [styles.DragImg__grab]: isDragging
  });

  return (
    <div 
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseLeave}
      className={styles.DragImg}
      ref={viewport}
    >
      <div className={styles.DragImg__container} ref={containerRef}>
        <img
          ref={imgRef}
          src={`${image.imageUrl}`}
          alt={image.alt}
          className={imgStyle}
        />
      </div>

      <div className={styles.DragImg__notification}>
        <DraggingIcon /> Листай
      </div>
    </div>
  );
};

export default DragImg;
